<template>
  <div class="ticker">
    <br/>
    <br/>
    <div v-if="ticker_data != null">
      <VTextMarquee :speed="85">{{ ticker_data.ticker}}</VTextMarquee>
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </div>
</template>

<script>
import axios from "axios";
import { VTextMarquee } from 'vue-text-marquee';

export default {
  name: 'ticker',
    components : {
      VTextMarquee: VTextMarquee
    },
    computed: {
    },
    data () {
      return {
          debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
          publicPath: process.env.BASE_URL,
          ticker_data: null,
          pleaseWait: true,
      }
    },
    methods:{
      getTickerData() {
          //console.log("get profiles")
          var url = (this.debugMode ? "http://localhost:8080/ticker" : "https://axes2api.azurewebsites.net/ticker")
          axios.get(url, {})
          .then((response) => {
              //console.log(response.data)
              this.ticker_data = response.data;
          }, (error) => {
              console.log(error);
          });
      },
    },
    mounted(){
      this.getTickerData();
    }
}
function Axes2Scorecards(user, averageThrow, totalThrows, totalBulls, scorecards, playerCountry) {
	this.user = user;
	this.averageThrow = averageThrow;
  this.totalThrows = totalThrows;
  this.totalBullseyes = totalBulls;
	this.scorecards = scorecards;
  this.showCards = false;
  this.playerCountry = playerCountry;
}
</script>

<style lang="scss">
.ticker {
  font-family: Verdana;
  background-Color: black;
  color: white;
}
.running {
  font-size: 6em !important;

}
</style>